import React, { useState, Fragment } from 'react'
import { IconButton } from '@material-ui/core'
import {
  PrintRounded
} from '@material-ui/icons'

import { PrintWindow } from 'components'

export const WebsiteBookingsOptions = ({ children }) => {
  const [openPrintWindow, setPrintWindow] = useState(false)

  const onButtonClick = () => {
    setPrintWindow(true)

    setTimeout(() => {
      setPrintWindow(false)
    }, 2000)
  }

  return (
    <Fragment>
      <IconButton onClick={onButtonClick}>
        <PrintRounded />
      </IconButton>

      {openPrintWindow && (
        <PrintWindow>
          {children}
        </PrintWindow>
      )}
    </Fragment>
  )

}


// WEBPACK FOOTER //
// ./src/components/WebsiteBookingsOptions/WebsiteBookingsOptions.js